import { useRef } from "react";

export const useClearInputByRef = () => {
    const inputCustomFieldRef = useRef<(HTMLInputElement | null)[]>([]);

    const resetCustomFieldInputs = () => {
        if (inputCustomFieldRef.current) {
            inputCustomFieldRef.current.forEach((ref: any) => {
                if (ref) ref.value = ''
            })
        }
    }

    return { resetCustomFieldInputs, inputCustomFieldRef }
}

export default useClearInputByRef